(function () {
  'use strict';

  function initPreloader() {
    const pre = document.getElementById('ga-preloader');
    if (!pre) return;
    window.addEventListener('load', () => {
      setTimeout(() => {
        pre.classList.add('done');
        startHeroEntrance();
      }, 1800);
    });
  }

  function startHeroEntrance() {
    const eye   = document.getElementById('ga-hero-eye');
    const l1    = document.getElementById('ga-hero-l1');
    const l2    = document.getElementById('ga-hero-l2');
    const sub   = document.getElementById('ga-hero-sub');
    const cta   = document.getElementById('ga-hero-cta');
    const stats = document.getElementById('ga-hero-stats');
    const scr   = document.getElementById('ga-hero-scroll');

    const t = 'opacity .9s cubic-bezier(0.25,0.1,0.25,1), transform .9s cubic-bezier(0.25,0.1,0.25,1)';
    const tSlide = 'transform 1s cubic-bezier(0.25,0.1,0.25,1)';

    function reveal(el, delay, props) {
      if (!el) return;
      setTimeout(() => { el.style.transition = t; Object.assign(el.style, props); }, delay);
    }

    if (eye)   reveal(eye,   100, { opacity:'1', transform:'translateY(0)' });
    if (l1)    setTimeout(() => { l1.style.transition = tSlide; l1.style.transform = 'translateY(0)'; }, 300);
    if (l2)    setTimeout(() => { l2.style.transition = tSlide; l2.style.transform = 'translateY(0)'; }, 480);
    if (sub)   reveal(sub,   700, { opacity:'1', transform:'translateY(0)' });
    if (cta)   reveal(cta,   900, { opacity:'1', transform:'translateY(0)' });
    if (stats) reveal(stats, 1100, { opacity:'1' });
    if (scr)   reveal(scr,   1300, { opacity:'1' });
  }

  function initCursor() {
    if (!window.matchMedia('(hover:hover)').matches) return;
    const dot  = document.getElementById('ga-cur-dot');
    const ring = document.getElementById('ga-cur-ring');
    const lbl  = document.getElementById('ga-cur-label');
    if (!dot || !ring) return;

    let mx = window.innerWidth / 2, my = window.innerHeight / 2;
    let rx = mx, ry = my;

    document.addEventListener('mousemove', e => { mx = e.clientX; my = e.clientY; });

    (function animRing() {
      rx += (mx - rx) * .12;
      ry += (my - ry) * .12;
      dot.style.left  = mx + 'px'; dot.style.top  = my + 'px';
      ring.style.left = rx + 'px'; ring.style.top = ry + 'px';
      if (lbl) { lbl.style.left = mx + 'px'; lbl.style.top = my + 'px'; }
      requestAnimationFrame(animRing);
    })();

    document.querySelectorAll('a, button').forEach(el => {
      const label = el.dataset.label || '';
      el.addEventListener('mouseenter', () => {
        dot.classList.add('expand'); ring.classList.add('expand');
        if (lbl && label) { lbl.textContent = label; lbl.classList.add('show'); }
      });
      el.addEventListener('mouseleave', () => {
        dot.classList.remove('expand'); ring.classList.remove('expand');
        if (lbl) lbl.classList.remove('show');
      });
    });
  }

  function initNav() {
    const nav = document.querySelector('.ga-nav');
    if (!nav) return;
    const onScroll = () => nav.classList.toggle('scrolled', window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    const btn = nav.querySelector('.ga-nav__mobile-btn');
    const links = nav.querySelector('.ga-nav__left');
    if (btn && links) {
      btn.addEventListener('click', () => {
        const open = links.style.display === 'flex';
        links.style.display      = open ? '' : 'flex';
        links.style.flexDirection = 'column';
        links.style.position     = 'absolute';
        links.style.top          = '100%';
        links.style.left         = '0';
        links.style.right        = '0';
        links.style.padding      = '24px var(--ga-side)';
        links.style.background   = 'rgba(15,15,16,0.97)';
        links.style.borderBottom = '1px solid var(--ga-border)';
        links.style.gap          = '20px';
      });
    }
  }

  function initReveals() {
    const els = document.querySelectorAll('.ga-reveal, .ga-coffee-card, .ga-why__col');
    if (!els.length) return;
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('ga-on'); io.unobserve(e.target); }
      });
    }, { threshold: .1, rootMargin: '0px 0px -40px 0px' });
    els.forEach((el, i) => {
      if (el.classList.contains('ga-coffee-card')) el.style.transitionDelay = (i % 4) * .1 + 's';
      if (el.classList.contains('ga-why__col'))    el.style.transitionDelay = i * .12 + 's';
      io.observe(el);
    });
  }

  function initParallax() {
    const heroMedia = document.querySelector('.ga-hero__media');
    const philWord  = document.querySelector('.ga-phil__bg-word');
    let ticking = false;

    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          const sy = window.scrollY;
          if (heroMedia && sy < window.innerHeight) {
            heroMedia.style.transform = `translateY(${sy * .12}px)`;
          }
          if (philWord) {
            const rect = philWord.closest('.ga-phil')?.getBoundingClientRect();
            if (rect) {
              const progress = -rect.top / window.innerHeight;
              philWord.style.transform = `translateY(calc(-50% + ${progress * 60}px))`;
            }
          }
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  function initDragScroll() {
    const wrap = document.querySelector('.ga-roasters__wrap');
    if (!wrap) return;
    let isDown = false, startX = 0, scrollLeft = 0;

    wrap.addEventListener('mousedown', e => {
      isDown = true; startX = e.pageX - wrap.offsetLeft; scrollLeft = wrap.scrollLeft;
      wrap.style.cursor = 'grabbing';
    });
    wrap.addEventListener('mouseleave', () => { isDown = false; wrap.style.cursor = 'grab'; });
    wrap.addEventListener('mouseup',    () => { isDown = false; wrap.style.cursor = 'grab'; });
    wrap.addEventListener('mousemove',  e => {
      if (!isDown) return; e.preventDefault();
      wrap.scrollLeft = scrollLeft - (e.pageX - wrap.offsetLeft - startX) * 1.2;
    });
    wrap.addEventListener('touchstart', e => { startX = e.touches[0].pageX; scrollLeft = wrap.scrollLeft; }, { passive: true });
    wrap.addEventListener('touchmove',  e => { wrap.scrollLeft = scrollLeft - (e.touches[0].pageX - startX); }, { passive: true });
  }

  function initNewsletter() {
    const form = document.querySelector('.ga-newsletter__form');
    if (!form) return;
    form.addEventListener('submit', e => {
      e.preventDefault();
      const btn   = form.querySelector('.ga-newsletter__btn');
      const input = form.querySelector('.ga-newsletter__input');
      if (!input?.value) return;
      if (btn) { btn.textContent = 'Thank you'; btn.style.background = '#3B5A2A'; }
      if (input) { input.value = ''; input.placeholder = "You're on the list."; }
      setTimeout(() => {
        if (btn) { btn.textContent = 'Subscribe'; btn.style.background = ''; }
        if (input) { input.placeholder = 'Your email address'; }
      }, 4000);
    });
  }

  function init() {
    initPreloader();
    initCursor();
    initNav();
    initReveals();
    initParallax();
    initDragScroll();
    initNewsletter();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();